import React from "react"
import * as s from "./ThankYou.module.css";

const ThankYou = () => {
  return (
    <div className={`${s.thankYou} thank-you`}>
      <h3>Thank You</h3>
      <h5>You Were Successfully Subscribed.</h5>
    </div>
  )
}

export default ThankYou
